import React, { useContext, useEffect, useState } from "react";
import { post } from "../../../utils/api";
import { AuthContext } from "../../../Context/AuthContextProvider";
import OtpInput from "react-otp-input";
import { toast } from "react-hot-toast";
import Lottie from "lottie-react";
import eotp1 from "../../../Assets/Media/LottiesJSONs/eotp1.json";
import eotp2 from "../../../Assets/Media/LottiesJSONs/eotp2.json";
import eotp3 from "../../../Assets/Media/LottiesJSONs/eotp3.json";
import wrong from "../../../Assets/Media/LottiesJSONs/wrongotp.json";
import { useMediaQuery } from "react-responsive";

function EmailOTPAuthentication() {
  const { loginUser, updateLoginUser } = useContext(AuthContext);
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("getOtp"); // Step flow: "getOtp" -> "verifyOtp" -> "verificationResult"
  const [verificationMessage, setVerificationMessage] = useState("");
  const [isOtpValid, setIsOtpValid] = useState(null); // null = not verified, true = success, false = failure

  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [timer, setTimer] = useState(60);
  const [updatedUser, SetUpdatedUser] = useState();
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  useEffect(() => {
    let interval = null;
    if (step === "verifyOtp" && !resendEnabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setResendEnabled(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timer, step, resendEnabled]);

  const formatTime = (seconds) => {
    return `${seconds}s`;
  };

  const sendOTP = async () => {
    setIsLoading(true);
    try {
      const response = await post("/sam/doc/users/send-email-otp", {
        email_id: loginUser.email_id
      });
      toast.success(
        response.message ||
          `OTP sent successfully to ${loginUser.email_id}.`
      );
      setStep("verifyOtp");
      setResendEnabled(false);
      setTimer(60); // Reset timer to 60 seconds
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOTP = async () => {
    setIsVerifyLoading(true);
    try {
      const response = await post("/sam/doc/users/verify-email-otp", {
        email_id: loginUser.email_id,
        otp,
      });
      SetUpdatedUser(response.user);
      setVerificationMessage(response.message);
      setIsOtpValid(true);
      setStep("verificationResult");
    } catch (error) {
      setVerificationMessage(error.response?.data?.message || "Error verifying OTP");
      setIsOtpValid(false);
      setStep("verificationResult");
    } finally {
      setIsVerifyLoading(false);
    }
  };

  const handleClose = (event) => {
    event.preventDefault(); // Prevent default action
    setStep("getOtp");

    if (updatedUser) {
      updateLoginUser(updatedUser);
    }
    document.getElementById("my_modal_2").close();
  };

  return (
    <div className="!p-0 !border-0">
      <div>
        {loginUser.email_id}
        <span
          className={` ${
            loginUser.isEmailVerified
              ? "!bg-[#17C653] text-white "
              : "!bg-[#fde58a] text-black cursor-pointer hover:!bg-[#fbbd24]"
          } !px-2 !py-[4px]  rounded-[4px] text-[12px]  ml-[8px]`}
        >
          {" "}
          {loginUser.isEmailVerified ? (
            " Verified"
          ) : (
            <span
              onClick={() => document.getElementById("my_modal_2").showModal()}
            >
              Please Verify
            </span>
          )}
        </span>
      </div>

      <dialog id="my_modal_2" className="modal">
        <div className="modal-box  modal-box-graident-border text-center  main-bg text-center">
          <div className="main-bg p-[20px] md:p-[40px] rounded-[12px]">
            <form method="dialog">
              <button
                className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                onClick={handleClose}
              >
                ✕
              </button>
            </form>
            <span className="text-pent2 title">OTP Verification</span>
            {step === "getOtp" && (
              <div>
                <Lottie
                  animationData={eotp1}
                  loop
                  autoplay
                  style={{
                    width: isMobile ? "250px" : "300px",
                    height: isMobile ? "250px" : "300px",
                    background: "transparent",
                    scale: 5,
                    margin: "auto",
                  }}
                />
                <p className="paragraph my-[20px]">
                  We will send a one-time password to your email address{" "}
                  {loginUser.email_id}
                </p>

                <button onClick={sendOTP} className="main-button custom-btn">
                  {isLoading ? "Getting OTP..." : "Get OTP"}
                </button>
              </div>
            )}

            {step === "verifyOtp" && (
              <div className="text-center">
                <Lottie
                  animationData={eotp2}
                  loop
                  autoplay
                  style={{
                    width: isMobile ? "250px" : "300px",
                    height: isMobile ? "250px" : "300px",
                    background: "transparent",
                    scale: 5,
                    margin: "auto",
                  }}
                />
                <p className="paragraph my-[20px]">
                  Enter the OTP sent to your email address <br />
                  {loginUser.email_id}
                </p>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span> </span>}
                  containerStyle="flex justify-center gap-[8px] mt-[20px]"
                  inputStyle="!bg-white !p-[12px] !w-[40px] !h-[40px] !border !border-[#b99653] !rounded !text-[#b99553] text-[24px] font-bold"
                  renderInput={(props) => <input {...props} />}
                />
                <div className="flex gap-[4px] items-center justify-center my-[20px]">
                  <p>Didn&apos;t receive the OTP?</p>
                  <button
                    onClick={sendOTP}
                    className={`text-blue-500 ${
                      !resendEnabled ? "cursor-not-allowed opacity-50" : ""
                    }`}
                    disabled={!resendEnabled}
                  >
                    Resend OTP
                  </button>
                  {!resendEnabled && <p>{`in ${formatTime(timer)}`}</p>}
                </div>
                <button onClick={verifyOTP} className="main-button custom-btn">
                  {isVerifyLoading ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            )}

            {step === "verificationResult" && (
              <div>
                {isOtpValid ? (
                  <Lottie
                    animationData={eotp3}
                    loop
                    autoplay
                    style={{
                      width: isMobile ? "250px" : "300px",
                      height: isMobile ? "250px" : "300px",
                      background: "transparent",
                      margin: "auto",
                    }}
                  />
                ) : (
                  <Lottie
                    animationData={wrong} // Replace this with your new Lottie animation data variable
                    loop
                    autoplay
                    style={{
                      width: isMobile ? "250px" : "300px",
                      height: isMobile ? "250px" : "300px",
                      background: "transparent",
                      margin: "auto",
                    }}
                  />
                )}

                <p className="paragraph my-[20px]">
                  {isOtpValid ? "Congratulations!" : "We are sorry!"}
                </p>
                <p className="paragraph my-[20px]">{verificationMessage}</p>

                <button
                  onClick={handleClose}
                  className="main-button custom-btn"
                >
                  DONE
                </button>
              </div>
            )}
          </div>
        </div>
      </dialog>
    </div>
  );
}

export default EmailOTPAuthentication;
